import React, {useState, useEffect} from 'react'
import {
    Modal,
    Button,
    ProgressBar
} from 'react-bootstrap'
import axios from 'axios'
import { formatUrl } from '../utils/urls';

function ModalShowFile(props) {


    const [file,   setfile]                             = useState(null);
    const [name, setname]                               = useState((props.file) ? props.file.name : '');
    const [format, setformat]                           = useState('');

    useEffect(() => {
        if(props.file !== file && props.file !== null && props.file !== undefined){
            setfile(props.file);
            let filename = props.file.name.split('.');
            let formattext = filename[filename.length - 1].toLowerCase();
            setformat(formattext);
            let filenametext = props.file.name.substring(0, props.file.name.length - (formattext.length + 1));
            setname(filenametext);
        } 
    });

    return (
        <div>
            <Modal show={props.show} onHide={props.close}>
                <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Visualizar {props.file ? 'archivo' : 'archivo'}</strong>
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {file !== null &&
                        <div className="file-creator">
                            <div className="row">
                                <div className="col-12">
                                    <h6>
                                        Nombre del archivo: <strong>{file.name}</strong>
                                    </h6> 
                                    <h6 className="d-none">
                                        Preview:
                                    </h6>  
                                    {(format === 'pdf') &&
                                        <div className="alert alert-light">
                                            <h6 className="mb-0">
                                                No es posible mostrar la vista previa para este tipo de archivo.
                                            </h6>
                                        </div> 
                                    }
                                    {(format === 'png' || format === 'jpg' || format === 'jpeg') &&
                                        <div className="py-3 preview text-center">
                                            <div className="container">
                                                <img 
                                                    className="img-fluid"
                                                    src={formatUrl(file.file)}  
                                                    alt="preview"
                                                />
                                            </div>
                                        </div> 
                                    }
                                    {(format === 'mp4' || format === 'mkv') &&
                                        <div className="py-3 preview text-center">
                                            <video width="400" height="240" controls>
                                                <source src={formatUrl(file.file)} type={'video/'+format} />
                                                Este navegador no es compatible con este video.
                                            </video>
                                        </div> 
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={props.close}>
                        <i className="fa fa-times mr-2"></i> Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ModalShowFile
